import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/login', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f7fa] text-[#3F4765]">
      <div className="bg-white shadow-md rounded-lg px-6 py-4">
        <p>Signing you out...</p>
      </div>
    </div>
  );
}

export default Logout;

